import {
  httpGet,
  httpPost,
  httpPatch,
  httpPatchMerge,
  httpDelete,
} from './http'
import type { TEntityId } from '~/types/models'
import type {
  ISupplierProductItem,
  ISupplierProductItemForPost,
} from '~/types/supplierProductItem/models'
import { stripRootLevelProductGroup } from '~/cynqueModules/dataObjects/SupplierProduct'

const apiEntityPath = '/api/supplierproductitems'

export async function getSupplierProductItems({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getSupplierProductItems.name
  const items = await httpGet<ISupplierProductItem[]>({ callingMn, apiPath })
  // TEMP TESTING SHIM — strip root-level productGroup off each item's embedded
  // supplier-product(s) (see stripRootLevelProductGroup).
  return items.map((item) => ({
    ...item,
    supplierProduct: stripRootLevelProductGroup(item.supplierProduct),
    ...(item.childSupplierProduct && {
      childSupplierProduct: stripRootLevelProductGroup(
        item.childSupplierProduct
      ),
    }),
  }))
}

export async function createSupplierProductItem(
  entity: ISupplierProductItemForPost
) {
  const callingMn = createSupplierProductItem.name
  const apiPath = apiEntityPath
  return httpPost<ISupplierProductItemForPost>({ callingMn, apiPath, entity })
}

export async function updateSupplierProductItem(
  entityData: Partial<ISupplierProductItem>,
  id: TEntityId
) {
  const callingMn = updateSupplierProductItem.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialISupplierProductItem = Partial<ISupplierProductItem>
  return httpPatchMerge<TPartialISupplierProductItem>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function updateSupplierProductItemSeqNums(
  updateData: Partial<ISupplierProductItem>[]
) {
  const callingMn = updateSupplierProductItemSeqNums.name
  const apiPath = apiEntityPath
  return httpPatch({
    callingMn,
    apiPath,
    entityData: updateData,
  })
}

export async function deleteSupplierProductItem(
  entityData: ISupplierProductItem
) {
  const callingMn = deleteSupplierProductItem.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
